import { render, staticRenderFns } from "./CurationListComponent.vue?vue&type=template&id=cdcfe180&scoped=true&"
import script from "./CurationListComponent.vue?vue&type=script&lang=js&"
export * from "./CurationListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcfe180",
  null
  
)

export default component.exports